import { render, staticRenderFns } from "./LoteInfo.vue?vue&type=template&id=6bbcdf71&"
import script from "./LoteInfo.vue?vue&type=script&lang=js&"
export * from "./LoteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports